import SavingsLineItemDescriptionWithToolTip from './savings-line-item-description-with-tooltip';
import { SavingsLineItem } from './savings-receipt';

interface SavingsReceiptSubLineItemProps {
  lineItem: SavingsLineItem;
}

export default function SavingsReceiptSubLineItem({
  lineItem,
}: SavingsReceiptSubLineItemProps) {
  return (
    <div className="ml-[16px] mt-[8px] flex flex-col">
      <div className="flex flex-row justify-between">
        {lineItem.subLineItemTooltipDescription ? (
          <SavingsLineItemDescriptionWithToolTip
            title={lineItem.description}
            description={lineItem.description}
            tooltipDescription={lineItem.subLineItemTooltipDescription}
            isSubLineItem={true}
          />
        ) : (
          <p className="body3 text-flexcar-neutral50">{lineItem.description}</p>
        )}

        <p className="body3 text-flexcar-neutral50">{lineItem.price}</p>
      </div>

      {lineItem.subDescription ? (
        <p className="body3 text-flexcar-neutral50">{lineItem.subDescription}</p>
      ) : null}
    </div>
  );
}
